import React, { useRef } from 'react';
import { Ci2EditPopover, Ci2EditPopoverActions } from './Ci2EditPopover';
import { DefeitosColorPalettePopover, SEV_OPTS, TIPO_OS_FIELDS, normOsFlag } from './defeitosVerveTableUi';

const FIELD_SUBS = {
  board: 'Defina o código de alerta exibido no board para este defeito.',
  classif: 'Informe tags separadas por Enter para classificar o defeito.',
  sev: 'Selecione o nível de criticidade aplicado a este defeito.',
  tipoos: 'Marque os tipos de ordem de serviço permitidos para este defeito.',
};

export function Dv2BoardEditPopover({ open, anchorRef, row, api }) {
  const { draftBoard, setDraftBoard, saving, cancelEdit, saveEdit } = api;
  const cod = String(row.TB01048_CODIGO).trim();
  const isSaving = saving?.cod === cod && saving?.field === 'board';
  const inputRef = useRef(null);
  const inputId = `dv2-board-${cod}`;

  return (
    <Ci2EditPopover
      open={open}
      anchorRef={anchorRef}
      onClose={cancelEdit}
      width={250}
      maxHeight={290}
      estimatedHeight={170}
      title="Cód. board"
      className="ci2-edit-popover--grupo ci2-edit-popover--single"
      initialFocusRef={inputRef}
    >
      <div className="ci2-edit-popover-head ci2-edit-popover-head--shadcn">
        <h4 className="ci2-edit-popover-title">Cód. board</h4>
        <p className="ci2-edit-popover-sub">{FIELD_SUBS.board}</p>
      </div>
      <div className="ci2-edit-popover-body ci2-grupo-rows">
        <div className="ci2-grupo-row">
          <label className="ci2-grupo-row-label" htmlFor={inputId}>
            Código
          </label>
          <div className="ci2-grupo-row-field">
            <input
              id={inputId}
              ref={inputRef}
              type="text"
              className="ci2-pop-input ci2-pop-input-mono ci2-grupo-row-input"
              value={draftBoard}
              onChange={(e) => setDraftBoard(e.target.value.slice(0, 4).toUpperCase())}
              maxLength={4}
              autoComplete="off"
              spellCheck={false}
              placeholder="Ex: AB01"
            />
          </div>
        </div>
      </div>
      <Ci2EditPopoverActions
        onCancel={cancelEdit}
        onConfirm={() => saveEdit(row)}
        confirmDisabled={false}
        saving={isSaving}
        confirmTitle="Salvar código board"
      />
    </Ci2EditPopover>
  );
}

export function Dv2ClassifEditPopover({ open, anchorRef, row, api }) {
  const { draftTags, tagInput, setTagInput, addTagFromInputAndSave, removeTagAndSave, saving, cancelEdit } = api;
  const cod = String(row.TB01048_CODIGO).trim();
  const isSaving = saving?.cod === cod && saving?.field === 'classif';
  const inputRef = useRef(null);
  const inputId = `dv2-classif-${cod}`;

  return (
    <Ci2EditPopover
      open={open}
      anchorRef={anchorRef}
      onClose={cancelEdit}
      width={250}
      maxHeight={340}
      estimatedHeight={200}
      title="Classificação"
      className="ci2-edit-popover--grupo ci2-edit-popover--single ci2-edit-popover--classif"
      initialFocusRef={inputRef}
    >
      <div className="ci2-edit-popover-head ci2-edit-popover-head--shadcn">
        <h4 className="ci2-edit-popover-title">Classificação</h4>
        <p className="ci2-edit-popover-sub">{FIELD_SUBS.classif}</p>
      </div>
      <div className="ci2-edit-popover-body dv2-classif-pop-body">
        <label className="dv2-classif-pop-label" htmlFor={inputId}>
          Tags
        </label>
        <div className="dv2-classif-tag-box">
          {draftTags.map((t) => (
            <span key={t} className="defeitos-vv-tag dv2-classif-tag-chip">
              {t}
              <button
                type="button"
                className="defeitos-vv-tag-remove"
                onClick={() => removeTagAndSave(row, t)}
                aria-label={`Remover ${t}`}
              >
                ×
              </button>
            </span>
          ))}
          <input
            id={inputId}
            ref={inputRef}
            type="text"
            className="dv2-classif-tag-input"
            value={tagInput}
            onChange={(e) => setTagInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === 'Tab') {
                if (e.key === 'Enter') e.preventDefault();
                addTagFromInputAndSave(row);
              }
            }}
            placeholder={draftTags.length ? '' : 'Digite e Enter'}
            autoComplete="off"
            spellCheck={false}
          />
        </div>
      </div>
      <Ci2EditPopoverActions
        onCancel={cancelEdit}
        onConfirm={cancelEdit}
        confirmDisabled={false}
        saving={isSaving}
        confirmTitle="Fechar"
      />
    </Ci2EditPopover>
  );
}

export function Dv2SevEditPopover({ open, anchorRef, row, api }) {
  const { draftSev, setDraftSev, saving, cancelEdit, saveEdit } = api;
  const cod = String(row.TB01048_CODIGO).trim();
  const isSaving = saving?.cod === cod && saving?.field === 'sev';

  return (
    <Ci2EditPopover
      open={open}
      anchorRef={anchorRef}
      onClose={cancelEdit}
      width={250}
      maxHeight={320}
      estimatedHeight={200}
      title="Criticidade"
      className="ci2-edit-popover--grupo ci2-edit-popover--single"
    >
      <div className="ci2-edit-popover-head ci2-edit-popover-head--shadcn">
        <h4 className="ci2-edit-popover-title">Criticidade</h4>
        <p className="ci2-edit-popover-sub">{FIELD_SUBS.sev}</p>
      </div>
      <div className="ci2-edit-popover-body dv2-sev-pop-body">
        <div className="dv2-sev-radio-group" role="radiogroup" aria-label="Criticidade">
          {SEV_OPTS.map((o) => (
            <label key={o.v} className="dv2-sev-radio-item">
              <input
                type="radio"
                className="dv2-sev-radio-input"
                name={`dv2-sev-${cod}`}
                value={o.v}
                checked={draftSev === o.v}
                onChange={() => setDraftSev(o.v)}
              />
              <span className="dv2-sev-radio-mark" aria-hidden />
              <span className="dv2-sev-radio-text">{o.l}</span>
            </label>
          ))}
        </div>
      </div>
      <Ci2EditPopoverActions
        onCancel={cancelEdit}
        onConfirm={() => saveEdit(row)}
        confirmDisabled={false}
        saving={isSaving}
        confirmTitle="Salvar criticidade"
      />
    </Ci2EditPopover>
  );
}

export function Dv2ColorEditPopover({ open, anchorRef, row, api }) {
  const {
    draftColor,
    setDraftColor,
    colorPaletteOpen,
    setColorPaletteOpen,
    colorEditAnchorRef,
    closeColorPalette,
    saving,
    cancelEdit,
    saveEdit,
  } = api;
  const cod = String(row.TB01048_CODIGO).trim();
  const isSaving = saving?.cod === cod && saving?.field === 'color';
  const inputRef = useRef(null);
  const inputId = `dv2-color-${cod}`;

  return (
    <Ci2EditPopover
      open={open}
      anchorRef={anchorRef}
      onClose={cancelEdit}
      width={250}
      maxHeight={320}
      estimatedHeight={200}
      title="Cor"
      className="ci2-edit-popover--grupo ci2-edit-popover--single"
      initialFocusRef={inputRef}
    >
      <div className="ci2-edit-popover-head ci2-edit-popover-head--shadcn">
        <h4 className="ci2-edit-popover-title">Cor</h4>
        <p className="ci2-edit-popover-sub">Defina a cor de destaque do defeito no board.</p>
      </div>
      <div className="ci2-edit-popover-body ci2-grupo-rows">
        <div className="ci2-grupo-row">
          <label className="ci2-grupo-row-label" htmlFor={inputId}>
            Hex
          </label>
          <div className="ci2-grupo-row-field dv2-color-pop-field">
            <input
              id={inputId}
              ref={inputRef}
              type="text"
              className="ci2-pop-input ci2-pop-input-mono ci2-grupo-row-input"
              value={draftColor}
              onChange={(e) => setDraftColor(e.target.value.slice(0, 7))}
              placeholder="#RRGGBB"
              maxLength={7}
              autoComplete="off"
              spellCheck={false}
            />
            <button
              type="button"
              className="defeitos-vv-color-swatch-btn"
              onClick={(e) => {
                e.stopPropagation();
                setColorPaletteOpen((o) => !o);
              }}
              aria-expanded={colorPaletteOpen}
              title="Abrir paleta"
            >
              <span
                className="defeitos-vv-color-swatch defeitos-vv-color-swatch--edit"
                style={{
                  background: /^#[0-9A-Fa-f]{6}$/.test(draftColor) ? draftColor : '#e2e8f0',
                }}
                aria-hidden
              />
            </button>
            <DefeitosColorPalettePopover
              open={colorPaletteOpen}
              anchorRef={colorEditAnchorRef}
              draftColor={draftColor}
              onDraftChange={setDraftColor}
              onClose={closeColorPalette}
            />
          </div>
        </div>
      </div>
      <Ci2EditPopoverActions
        onCancel={cancelEdit}
        onConfirm={() => saveEdit(row)}
        confirmDisabled={false}
        saving={isSaving}
        confirmTitle="Salvar cor"
      />
    </Ci2EditPopover>
  );
}

export function Dv2TipoOsEditPopover({ open, anchorRef, row, api }) {
  const { draftTipoFlags, setDraftTipoFlags, saving, cancelEdit, saveEdit } = api;
  const cod = String(row.TB01048_CODIGO).trim();
  const isSaving = saving?.cod === cod && saving?.field === 'tipoos';

  return (
    <Ci2EditPopover
      open={open}
      anchorRef={anchorRef}
      onClose={cancelEdit}
      width={250}
      maxHeight={360}
      estimatedHeight={280}
      title="Tipo de OS"
      className="ci2-edit-popover--grupo ci2-edit-popover--single"
    >
      <div className="ci2-edit-popover-head ci2-edit-popover-head--shadcn">
        <h4 className="ci2-edit-popover-title">Tipo de OS</h4>
        <p className="ci2-edit-popover-sub">{FIELD_SUBS.tipoos}</p>
      </div>
      <div className="ci2-edit-popover-body ci2-grupo-rows">
        <div className="ci2-grupo-row ci2-grupo-row--stack">
          <span className="ci2-grupo-row-label">Tipos</span>
          <div className="ci2-grupo-row-field dv2-tipo-pop-options">
            {TIPO_OS_FIELDS.map((f) => (
              <label key={f.db} className="defeitos-vv-tipo-option dv2-tipo-pop-option">
                <input
                  type="checkbox"
                  checked={normOsFlag(draftTipoFlags?.[f.db]) === 1}
                  onChange={(e) =>
                    setDraftTipoFlags((prev) => ({
                      ...prev,
                      [f.db]: e.target.checked ? 1 : 0,
                    }))
                  }
                />
                <span>{f.label}</span>
              </label>
            ))}
          </div>
        </div>
      </div>
      <Ci2EditPopoverActions
        onCancel={cancelEdit}
        onConfirm={() => saveEdit(row)}
        confirmDisabled={false}
        saving={isSaving}
        confirmTitle="Salvar tipos de OS"
      />
    </Ci2EditPopover>
  );
}
